<div class="rules-group-container">
    <div class="rules-group-header clearfix">
        <div class="group-operations pull-left">
            <div class="btn-group group-conditions">
                <wms-toggle class="wms-toggle switch" [id]="id"  (onChange)="onChange($event, 'AND', 'OR');filterCriteriaService.markVariableUpdated()" [onLabel]="'AND'" [offLabel]="'OR'" [onValue]="'AND'"
                    [offValue]="'OR'" [model]="rules.condition"></wms-toggle>
            </div>
        </div>
        <div class="btn-group pull-right group-actions">
            <button type="button" class="app-button btn btn-transparent" (click)="filterCriteriaService.addRule(rules)">
                <i class="wm-icon12 wms wms-add"></i>
                <span class="btn-caption">{{locale.LABEL_ADD_CRITERIA}}</span>
            </button>
            <button *ngIf="showGroupButton()" type="button" class="app-button btn btn-transparent" (click)="addGroup()">
                <i class="wm-icon12 wms wms-add"></i>
                <span class="btn-caption">{{locale.LABEL_ADD_GROUP}}</span>
            </button>
            <button *ngIf="!isDefaultGroup" type="button" class="app-button btn btn-transparent"
                title="{{locale.LABEL_DELETE_GROUP}}" (click)="deleteGroup()">
                <i class="wm-icon12 wms wms-delete"></i>
            </button>
        </div>
    </div>
    <div class="rules-group-body">
        <ul class="rules-list">
            <div *ngFor="let rule of rules.rules" class="rules-wrapper">
                <wms-criteria-rule [liveWidgetSettingsService]="liveWidgetSettingsService" [rule]="rule" [parentGroup]="rules"></wms-criteria-rule>
                <wms-criteria-group [filterFields]="filterFields" [depth]=getCurrentDepth() [rules]="rule" [liveWidgetSettingsService]="liveWidgetSettingsService"
                    [parentGroup]="rules" *ngIf="rule.rules"></wms-criteria-group>
            </div>
        </ul>
    </div>
</div>
